import taskIcon from '../assets/images/icons/task.svg';
const userSetup = {
  id: 'userSetup',
  type: 'group',
  children: [
    {
      id: 'userSetup',
      title: 'User Setup',
      type: 'collapse',
      icon: taskIcon,
      children: [
        {
          id: 'AdminScreenRoles',
          title: 'Admin Screen Role',
          type: 'item',
          url: '/userSetup/AdminScreenRoles',
          breadcrumbs: false,
          featureName: 'Administrator',
        },
        {
          id: 'ETrackUserMCNMapping',
          title: 'eTrack Users',
          type: 'item',
          url: '/userSetup/ETrackUserMCNMapping',
          breadcrumbs: false,
          featureName: 'Administrator',
        },
      ],
    },
  ],
};

export default userSetup;
